import axios from '../utility/axios-utils';
import useAuth from './useAuth';
// Refactor Code
const useRefreshToken = () => {
  const { setAuth } = useAuth();
  return async () => {
    const response = await axios.get('/refresh', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('user') || ''}`,
      },
      withCredentials: true,
    });
    setAuth((prev) => ({
      ...prev,
      accessToken: response.data.accessToken,
    }));
    return response.data.accessToken;
  };
};

export default useRefreshToken;
